.label {
  color: light-dark(var(--mantine-color-dimmed), var(--mantine-color-gray-4));
}

.dropdown {
  max-height: 300px;
  overflow-y: auto;
}
